import { useEffect } from 'react';
import api from '@/utils/api';

const ensureMeta = (attrName, attrValue, contentAttr = 'content') => {
  let el = document.head.querySelector(`meta[${attrName}="${attrValue}"]`);
  if (!el) {
    el = document.createElement('meta');
    el.setAttribute(attrName, attrValue);
    document.head.appendChild(el);
  }
  return { el, set: (v) => el.setAttribute(contentAttr, v || '') };
};

const setFavicon = (href) => {
  if (!href) return;
  let link = document.head.querySelector("link[rel='icon']") || document.head.querySelector("link[rel='shortcut icon']");
  if (!link) {
    link = document.createElement('link');
    link.rel = 'icon';
    document.head.appendChild(link);
  }
  link.href = href;
};

const applyIdentity = ({ seo = {}, hero = {}, branding = {} }) => {
  const title = seo.page_title || (hero.title ? `${hero.title} — ${hero.year || ''}`.trim().replace(/[—\-]\s*$/, '') : 'CEOs Family Lucky Draw');
  document.title = title;

  ensureMeta('name', 'description').set(seo.meta_description || '');
  ensureMeta('property', 'og:title').set(seo.og_title || title);
  ensureMeta('property', 'og:description').set(seo.og_description || seo.meta_description || '');
  ensureMeta('property', 'og:image').set(seo.og_image_url || '');
  ensureMeta('property', 'og:type').set('website');
  ensureMeta('name', 'twitter:card').set('summary_large_image');
  ensureMeta('name', 'twitter:title').set(seo.og_title || title);
  ensureMeta('name', 'twitter:description').set(seo.og_description || seo.meta_description || '');
  ensureMeta('name', 'twitter:image').set(seo.og_image_url || '');

  if (branding.favicon_url) setFavicon(branding.favicon_url);
};

/**
 * BrowserIdentity — reads seo, hero and branding settings and syncs
 * document.title, favicon, meta description and Open Graph tags.
 */
const BrowserIdentity = () => {
  useEffect(() => {
    let mounted = true;
    const load = async () => {
      try {
        const { data } = await api.get('/settings');
        if (mounted) applyIdentity({ seo: data.seo || {}, hero: data.hero || {}, branding: data.branding || {} });
      } catch {
        // ignore
      }
    };
    load();
    const onFocus = () => load();
    window.addEventListener('focus', onFocus);
    return () => {
      mounted = false;
      window.removeEventListener('focus', onFocus);
    };
  }, []);
  return null;
};

export default BrowserIdentity;
